import React from 'react';
import { GeneralEditorOverlay } from '../../editor/EditorOverlayNew/GeneralEditorOverlay';
export var HTMLBlock = function (props) {
    var post = props.post, isEditable = props.isEditable, dragHandleProps = props.dragHandleProps;
    return (React.createElement("div", null,
        React.createElement(GeneralEditorOverlay, { isEditable: isEditable, post: post, dragHandleProps: dragHandleProps }),
        React.createElement("div", { dangerouslySetInnerHTML: { __html: post === null || post === void 0 ? void 0 : post.text } })));
};
//# sourceMappingURL=HTMLBlock.js.mapimport React from 'react';
import { GeneralEditorOverlay } from '../../editor/EditorOverlayNew/GeneralEditorOverlay';
export var HTMLBlock = function (props) {
    var post = props.post, isEditable = props.isEditable, dragHandleProps = props.dragHandleProps;
    return (React.createElement("div", null,
        React.createElement(GeneralEditorOverlay, { isEditable: isEditable, post: post, dragHandleProps: dragHandleProps }),
        React.createElement("div", { dangerouslySetInnerHTML: { __html: post === null || post === void 0 ? void 0 : post.text } })));
};
//# sourceMappingURL=HTMLBlock.js.map